import { EVENT_DEFAULT_INSTANCE, type FormValues } from "@/widgets/classic-form/form";
import { locationScopeToDataModel } from "@/features/place-exactness";
import type { SearchDataModel } from "@/entities/data-model";

export function mapFormEventsToDataModel(formValues: FormValues) {
    const mappedEvents: Partial<SearchDataModel["events"]> = {};

    if (formValues.events) {
        Object.entries(formValues.events).forEach(([eventKey, event]) => {
            mappedEvents[eventKey] = {
                ...event,
                instances: event.instances.map(({ isRangeMode, ...instance }) => {
                    const locationExactness = locationScopeToDataModel(instance.locationExactness);
                    let dateProximity = instance.dateProximity;
                    let date = instance.date;
                    if (isRangeMode) {
                        dateProximity = EVENT_DEFAULT_INSTANCE.dateProximity;
                        date = structuredClone(date);
                        date.month = null;
                        date.day = null;
                    }
                    return {
                        ...instance,
                        date,
                        dateProximity,
                        locationExactness,
                    };
                }),
            };
        });
    }

    return mappedEvents;
}
